"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoMessage = exports.WarningMessage = exports.ErrorMessage = exports.SuccessMessage = exports.Message = exports.MessageBody = exports.MessageTitle = void 0;
const React = require("react");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const colors_1 = require("../../../../types/colors");
const css = (0, cssComposer_1.default)(styles, "Message");
/**
 * Renders header of a Message
 */
const MessageTitle = ({ children }) => (React.createElement("h4", { className: css("title") }, children));
exports.MessageTitle = MessageTitle;
/**
 *  Renders body of the message
 */
const MessageBody = ({ children }) => (React.createElement("div", { className: css("body") }, children));
exports.MessageBody = MessageBody;
/**
 * System messages - Plain, success and error variants
 *
 * Normally used for inline and non-blocking messages (e.g. input fields form validation)
 * as opposed to [Dialog](#dialog)
 */
const Message = ({ children, variant = "", className }) => {
    return (React.createElement("div", { className: css("", { className }, `-color-${variant}`), "data-test": "message" }, children));
};
exports.Message = Message;
exports.default = exports.Message;
const SuccessMessage = (props) => (React.createElement(exports.Message, Object.assign({ variant: colors_1.TColorVariants.Success }, props)));
exports.SuccessMessage = SuccessMessage;
const ErrorMessage = (props) => (React.createElement(exports.Message, Object.assign({ variant: colors_1.TColorVariants.Error }, props)));
exports.ErrorMessage = ErrorMessage;
const WarningMessage = (props) => (React.createElement(exports.Message, Object.assign({ variant: colors_1.TColorVariants.Warning }, props)));
exports.WarningMessage = WarningMessage;
const InfoMessage = (props) => (React.createElement(exports.Message, Object.assign({ variant: colors_1.TColorVariants.Info }, props)));
exports.InfoMessage = InfoMessage;
//# sourceMappingURL=index.js.map